import React from "react";

import "../practitioners/practitoner/practitoner.css";

import FavoriteToggle from "../favoritetoggle";

/**
 * One medium's info card on the Professional Sessions listing.
 *
 * Lifted verbatim out of practitioners/index.js so the favourites page can render
 * the identical card - the Book Now flow reads pre_pay_session_type /
 * post_pay_schedule / session_length straight off `item`, so the two screens must
 * not be allowed to drift apart.
 *
 * The only addition is the favourite toggle, which the caller owns: this
 * component renders `item.is_favorite` and reports taps, nothing more.
 */

const add3Dots = (string, limit) => {
  var dots = "...";
  if (string.length > limit) {
    // you can also use substr instead of substring
    string = string.substring(0, limit) + dots;
  }

  return string;
};

const checkSessionExtraPersion = (item) => {
  const obj = JSON.parse(item.session_length);

  const sessionKeys = Object.keys(obj);
  const isOffered = sessionKeys.includes("452") || sessionKeys.includes("602");
  if (isOffered) {
    return "";
  } else {
    return <em>Not Offered</em>;
  }
};

const checkSessionFoutyFiveExtraPersion = (item) => {
  const session_currency_obj = JSON.parse(item.session_currency);
  const obj = JSON.parse(item.session_length);
  const sessionCurrencyKeys = Object.keys(session_currency_obj);
  const sessionKeys = Object.keys(obj);
  const isOffered = sessionKeys.includes("452");
  const sessionCurrency = sessionCurrencyKeys.includes("452");
  let currency = "USD";
  if (sessionCurrency) {
    currency = session_currency_obj[452];
  }
  let diffreance = 0;
  if (isOffered) {
    let priceoFoutyFiveForTwo = obj[452];
    let isOfferedForTwo = sessionKeys.includes("45");
    if (isOfferedForTwo) {
      let priceoFoutyFive = obj[45];
      diffreance = priceoFoutyFiveForTwo - priceoFoutyFive;
    } else {
      diffreance = 0;
    }
    if (diffreance < 0) {
      return "- $ " + Math.abs(diffreance);
    } else {
      return "+ $ " + diffreance + " " + currency;
    }
  } else {
    return <em>Not Offered</em>;
  }
};

const checkSessionSixtyExtraPersion = (item) => {
  const session_currency_obj = JSON.parse(item.session_currency);
  const obj = JSON.parse(item.session_length);
  const sessionCurrencyKeys = Object.keys(session_currency_obj);
  const sessionKeys = Object.keys(obj);
  const isOffered = sessionKeys.includes("602");
  const sessionCurrency = sessionCurrencyKeys.includes("602");
  let currency = "USD";
  if (sessionCurrency) {
    currency = session_currency_obj[602];
  }
  let diffreance = 0;
  if (isOffered) {
    let priceoFoutyFiveForTwo = obj[602];
    let isOfferedForTwo = sessionKeys.includes("60");
    if (isOfferedForTwo) {
      let priceoFoutyFive = obj[60];
      diffreance = priceoFoutyFiveForTwo - priceoFoutyFive;
    } else {
      diffreance = 0;
    }
    if (diffreance < 0) {
      return "- $ " + Math.abs(diffreance);
    } else {
      return "+ $ " + diffreance + " " + currency;
    }
  } else {
    return <em>Not Offered</em>;
  }
};

const isfourtyFive = (item) => {
  if (item.session_length !== "" && item.session_length !== undefined) {
    const obj = JSON.parse(item.session_length);
    const sessionKeys = Object.keys(obj);
    const isOffered = sessionKeys.includes("452");
    if (!isOffered) {
      return true;
    }
  } else {
    return true;
  }
};

const isSixtyForTwo = (item) => {
  if (item.session_length !== "" && item.session_length !== undefined) {
    const obj = JSON.parse(item.session_length);
    const sessionKeys = Object.keys(obj);
    const isOffered = sessionKeys.includes("602");
    if (!isOffered) {
      return true;
    }
  } else {
    return true;
  }
};

export default function MediumCard({
  item,
  onBookNow,
  onViewProfile,
  onToggleFavorite = () => {},
  canFavorite = false,
  isTogglingFavorite = false,
  isOpeningProfile = false,
}) {
  return (
    <div className="schedule-advance-bx">
      <div className="profile-box-top">
        {canFavorite && (
          <FavoriteToggle
            isFavorite={item.is_favorite}
            disabled={isTogglingFavorite}
            onToggle={() => onToggleFavorite(item)}
          />
        )}
        <div className="left-prof-bx">
          <div className="prof-circal image-advance-client-profile padding-unset profile-wrapper">
            <img
              className="practioner-profile-image"
              src={
                item.profile_image !== ""
                  ? process.env.REACT_APP_IMAGE_URL + item.profile_image
                  : "images/user-dummy.png"
              }
              alt="avatar"
              width="130"
              height="130"
              loading="lazy"
              decoding="async"
            />
            {(item.is_verify_token == 1 || item.is_verify_token == 2) && (
              <div className="hoverContent">
                <div className="hover-container">
                  <div className="hover-target" tabIndex={0}>
                    <div className="verified-badge">VERIFIED</div>
                  </div>
                  <aside className="hover-popup-r hover-popup-small ">
                    <h2 className="hoverHeading">
                      <span className="hoverBadge">VERIFIED</span>
                    </h2>
                    <p className="verified-para">
                      Every medium listed has met rigorous standards; those
                      marked "verified" have also demonstrated exceptional skill
                      recently. Learn more about our verification process{" "}
                      <a
                        href="https://verified.verysoul.com/"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        here
                      </a>
                      .
                    </p>
                  </aside>
                </div>
              </div>
            )}
          </div>
        </div>
        <div className="left-name-bx">
          <span>{item.name}</span>
        </div>
        <div className="button-select-profile d-flex align-items-center justify-content-center">
          {item.show_flexbooker ? (
            <button
              className="book-nw"
              onClick={() => window.open(item.personal_booking_link, "_self")}
            >
              Book Now
            </button>
          ) : (
            item.session_length !== undefined &&
            item.session_length !== "[]" && (
              <button className="book-nw" onClick={() => onBookNow(item)}>
                Book Now
              </button>
            )
          )}
          <button
            className="view-pro"
            disabled={isOpeningProfile}
            onClick={() => onViewProfile(item)}
          >
            {isOpeningProfile ? "Opening..." : "View Profile"}
          </button>
        </div>
      </div>
      <div className="language-list-box">
        <ul>
          <li className="d-flex">
            <span className="min-width-70px">
              <img src="images/Language.png" alt="badge" />
              Languages:
            </span>
            <div>
              <em>{add3Dots(item.languages, 100)}</em>
            </div>
          </li>
          <li className="d-flex">
            <span className="min-width-70px">
              <img src="images/wordtow.png" alt="badge" />
              Country:
            </span>
            <div>
              <em>{item.country}</em>
            </div>
          </li>
          <li className="d-flex">
            <span className="min-width-70px">
              <img src="images/fluent_payment-48-filled.png" alt="badge" />
              Payment:
            </span>
            <div>
              {item.payType.includes(1) ? <em>Pay to Book </em> : ""}
              {item.payType.includes(2) ? <em>Pay After Session</em> : ""}
            </div>
          </li>
          <li className="d-flex">
            <span className="min-width-70px">
              <img src="images/ph_video-camera-fill.png" alt="badge" />
              Recording:
            </span>
            <div>
              {item.recording === 1 ? (
                <em>Allowed </em>
              ) : item.recording === 0 ? (
                <em>Not Available</em>
              ) : (
                ""
              )}
            </div>
          </li>
          <li className="d-flex margin-unset">
            <span className="min-width-70px">
              <img src="images/Badge_1_.png" alt="badge" />
              Offerings:
            </span>
            <div>{item.session_length === "[]" && <em>Not Offered</em>}</div>
          </li>

          {item.session_length !== undefined &&
            item.session_length !== "[]" &&
            Object.entries(JSON.parse(item.session_length)).map(
              ([key, value]) =>
                key != 452 && key != 602 ? (
                  <li className="d-flex margin-unset" key={key}>
                    <span className="min-width-70px">{key} Minutes:</span>
                    <div>
                      <em className="d-block">
                        $ {value}{" "}
                        {Object.values(JSON.parse(item.session_currency))[0]}
                      </em>
                    </div>
                  </li>
                ) : (
                  ""
                )
            )}

          <span className="prof-price-info app-prof"></span>

          <li className="d-flex margin-unset">
            <span className="min-width-70px">Extra Person:</span>
            <div>
              {item.session_length !== "" && checkSessionExtraPersion(item)}
            </div>
          </li>

          <>
            {item.session_length !== "" && isfourtyFive(item) ? (
              " "
            ) : (
              <li className="d-flex margin-unset">
                <span className="min-width-70px">45 Minutes for 2:</span>
                <em>
                  {item.session_length !== "" &&
                    checkSessionFoutyFiveExtraPersion(item)}
                </em>
              </li>
            )}
          </>

          <>
            {item.session_length !== "" && isSixtyForTwo(item) ? (
              " "
            ) : (
              <li className="d-flex margin-unset">
                <span className="min-width-70px">60 Minutes for 2:</span>
                <em>
                  {item.session_length !== "" &&
                    checkSessionSixtyExtraPersion(item)}
                </em>
              </li>
            )}
          </>
        </ul>
      </div>
    </div>
  );
}
